import { Box, Flex, Grid } from "@radix-ui/themes";
import { FC } from "react";

import SamsungScreen from "../../../shared/SamsungScreen";
import NoChallengePlanned from "../../../noChallengePlanned/noChallengePlanned";
import PrizeCard from "../../../challengeUpcoming/PrizeCard/PrizeCard";
import LeaderboardHeader from "../LeaderboardHeader/LeaderboardHeader";
import LeaderboardEmpty from "../LeaderboardEmpty/LeaderboardEmpty";
import LeaderboardList from "../LeaderboardList/LeaderboardList";
import LeaderboardHero from "../LeaderboardHero/LeaderboardHero";
import { LeaderboardProps } from "./LeaderboardUI.types";

// No Samsung prize confirmed for the Assembly event yet — hide the prize card
// for now. Flip to true (and set brand.prize) when a prize is finalised.
const SHOW_PRIZE = false;

const LeaderboardUI: FC<LeaderboardProps> = ({ data, leaderboardSize }) => {
  if (!data.hasOngoing) {
    return <NoChallengePlanned {...data} />;
  }

  if (leaderboardSize === "empty") {
    return <LeaderboardEmpty {...data} />;
  }

  const users = data.leaderboard.data ?? [];
  const leader = users[0];

  return (
    <SamsungScreen>
      <LeaderboardHeader endDate={data.challenge.data?.endDate} />

      <Grid className="sr-board__grid" columns="2fr 3fr" gap="4" width="100%">
        {/* Left: hero leader (+ prize when one is set) */}
        <Flex
          direction="column"
          gap="3"
          minHeight="0"
          justify={SHOW_PRIZE ? "start" : "center"}
        >
          <LeaderboardHero leader={leader} />
          {SHOW_PRIZE && (
            <Box className="sr-prize" flexGrow="1" overflow="hidden">
              <PrizeCard />
            </Box>
          )}
        </Flex>

        {/* Right: chasers + latest result */}
        <LeaderboardList chasers={users} data={users} />
      </Grid>
    </SamsungScreen>
  );
};

export default LeaderboardUI;
